import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "q-ml-sm text-subtitle1 text-bold" }, "Ej behörighet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "row items-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            size: "xs",
            name: "mdi-alert-circle-outline",
            color: "negative"
          }),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "row text-grey-8" }, {
        default: _withCtx(() => [
          _createTextVNode(" Du har ej behörighet för denna applikation, försök med en annan användare. ")
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          (_ctx.$route.path !== '/sign-in')
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                flat: "",
                label: "Logga ut",
                color: "primary",
                onClick: _ctx.onSignOut
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_q_btn, {
                key: 1,
                flat: "",
                label: "Ok",
                color: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPermissionModal = false))
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}